import React from "react";
import CrmDashboardView from "../../components/Admin/CRM/CrmDashboardView";

const CRMDashboard = () => {
  return <CrmDashboardView />;
};

export default CRMDashboard;
